/** @param {string} value */
export default (value) => value.replace(/<[^>]+>/gi, ''); //NOSONAR
